import { r as require$$0 } from '../../tslib/tslib.es6-f34bb380-2a421bf0.js';
import { r as requireTypes } from './types-cd111978-41089783.js';

var noParser = {};
(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports._Parser = exports.parse = void 0;
  var tslib_1 = require$$0;
  function parse() {
    throw new Error("You're trying to format an uncompiled message with react-intl without parser, please import from 'react-intl' instead");
  }
  exports.parse = parse;
  tslib_1.__exportStar(requireTypes(), exports);
  exports._Parser = undefined;
})(noParser);

export { noParser as n };
//# sourceMappingURL=no-parser-4ca289b2-583a995b.js.map
